import React from "react";
import resortsByCategory from "../../data/resortsByCategory";

const ResortSelector = ({ selectedCategory, selectedResort, onChange }) => {
  const resorts = resortsByCategory[selectedCategory] || [];

  if (!selectedCategory || resorts.length === 0) {
    return (
      <p className="text-sm italic text-gray-300">
        Please answer the resort category question above to view your resort
        options.
      </p>
    );
  }

  return (
    <div className="space-y-3">
      <label className="block text-sm font-medium text-textPrimary">
        Select Your Resort
        <span className="ml-1 text-red-500">*</span>
      </label>
      
      <div className="relative">
        <select
          className="px-3 py-2 w-full text-sm font-medium text-white bg-gray-700 rounded-lg border-2 border-gray-600 transition-all duration-200 appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:border-gray-500"
          value={selectedResort || ""}
          onChange={(e) => onChange("resort", e.target.value)}
        >
        <option value="" disabled>
          Choose a resort
        </option>
        {resorts.map((resort) => {
          const resortName = typeof resort === "string" ? resort : resort.name;
          return (
            <option key={resortName} value={resortName}>
              {resortName}
            </option>
          );
        })}
        </select>
        {/* Custom dropdown arrow */}
        <div className="flex absolute inset-y-0 right-0 items-center pr-3 pointer-events-none">
          <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>

      {selectedResort && resorts
        .find(
          (r) => (typeof r === "object" ? r.name : r) === selectedResort
        )
        ?.resortStrategyNotes?.length > 0 && (
        <div className="p-3 rounded-lg border bg-blue-900/20 border-blue-500/30">
          <p className="text-sm text-blue-300">
            {resorts
              .find(
                (r) => (typeof r === "object" ? r.name : r) === selectedResort
              )
              ?.resortStrategyNotes?.join(" • ")}
          </p>
        </div>
      )}
    </div>
  );
};

export default ResortSelector;